module.exports = __webpack_public_path__ + "img/whitefilter.c60ddd71.svg";